import { toast } from '@rentnerkev/toasts'
import { useForm } from '@tanstack/react-form'
import { useMutation } from '@tanstack/react-query'

import { requestPasswordResetHandler } from '@/features/Auth/ForgotPassword/server.ts'
import type { ForgotPasswordFormValues } from '@/features/Auth/ForgotPassword/Types/types.ts'
import useTranslationStore from '@/language/useTranslationStore.ts'
import { AppError, toastAppError } from '@/lib/Errors/AppError.ts'

export default function usePasswordForgotLogic() {
    const { t } = useTranslationStore()
    const form = useForm({
        defaultValues: {
            email: '',
        } satisfies ForgotPasswordFormValues,
        onSubmit: async ({ value }) => {
            resetMutation(value)
        },
    })

    const { mutate: resetMutation, isPending: isLoading } = useMutation({
        mutationFn: async function (formData: ForgotPasswordFormValues) {
            return await requestPasswordResetHandler({
                data: formData,
            })
        },
        onSuccess: function (result) {
            if (result.success) {
                toast.success(t('auth.forgotPassword.emailSent'), {
                    title: t('auth.forgotPassword.title'),
                })
                return
            }

            toastAppError(
                new AppError(
                    result.error || t('auth.forgotPassword.requestError'),
                ),
            )
        },
        onError: function (error) {
            toastAppError(error)
        },
    })

    return {
        state: {
            form,
            isLoading,
        },
    }
}
